// extracted by mini-css-extract-plugin
module.exports = {"MainContentContainer":"MainContent_MainContentContainer__33p0V","ColumnContentContainer":"MainContent_ColumnContentContainer__J5xBE"};